/* tslint:disable */
/* eslint-disable */
/**
 * IGA Gewinnspiel API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@wapp.gmbh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Optician
 */
export interface Optician {
    /**
     * 
     * @type {string}
     * @memberof Optician
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Optician
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Optician
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Optician
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Optician
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof Optician
     */
    streetAndNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Optician
     */
    zip?: string;
}

export function OpticianFromJSON(json: any): Optician {
    return OpticianFromJSONTyped(json, false);
}

export function OpticianFromJSONTyped(json: any, ignoreDiscriminator: boolean): Optician {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city': !exists(json, 'city') ? undefined : json['city'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'slug': !exists(json, 'slug') ? undefined : json['slug'],
        'streetAndNumber': !exists(json, 'streetAndNumber') ? undefined : json['streetAndNumber'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
    };
}

export function OpticianToJSON(value?: Optician | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city': value.city,
        'email': value.email,
        'id': value.id,
        'name': value.name,
        'slug': value.slug,
        'streetAndNumber': value.streetAndNumber,
        'zip': value.zip,
    };
}


